export default "__VITE_ASSET__CMyXu4_0__"